import { getProfileName } from "PFCore/helpers/profile";
import { useCurrentAccount } from "PFCore/hooks/queries/account/use_current_account";
import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import { useEffect } from "react";

import { applyPendoSnippet } from "./apply_pendo_snippet";

export const usePendo = () => {
  const { data: currentProfile } = useCurrentProfile();
  const { data: currentAccount } = useCurrentAccount();
  const { data: myAccountInfo } = useMyAccountInfo();

  const {
    config: {
      externalKeys: { pendoApiKey }
    }
  } = myAccountInfo;

  useEffect(() => {
    if (window.pendo || !pendoApiKey) {
      return;
    }
    applyPendoSnippet(pendoApiKey);
  }, [pendoApiKey]);

  useEffect(() => {
    if (!window.pendo || !currentProfile.id) {
      return;
    }

    window.pendo.initialize({
      visitor: {
        id: currentProfile.id,
        email: currentProfile.email,
        full_name: getProfileName(currentProfile),
        role: currentProfile.roles[0],
        permission_group: currentProfile.permissionsGroup.name,
        location: currentProfile.location?.[0]?.value,
        company: currentProfile.company?.[0].value,
        company_code: currentProfile.companyCode?.[0].value,
        competency: currentProfile.competency?.[0].value,
        cost_centre: currentProfile.costCentre?.[0].value,
        department: currentProfile.department?.[0].value,
        economic_location: currentProfile.economicLocation?.[0].value,
        gpn: currentProfile.gpn?.[0].value,
        grade: currentProfile.grade?.[0].value,
        gui: currentProfile.gui?.[0].value,
        hr_department: currentProfile.hrDepartment?.[0].value,
        job_title: currentProfile.jobTitle?.[0].value,
        level: currentProfile.level?.[0].value,
        management_region: currentProfile.managementRegion?.[0].value,
        project_roles: currentProfile.projectRoles?.map(({ value }) => value),
        region: currentProfile.region?.[0].value,
        sectors: currentProfile.sectors?.map(({ value }) => value),
        service_line: currentProfile.serviceLine?.[0].value,
        sub_area: currentProfile.subArea?.[0].value,
        sub_competency_area: currentProfile.subCompetencyArea?.[0].value,
        sub_service_line: currentProfile.subServiceLine?.[0].value,
        work_location_address_country: currentProfile.workLocationAddressCountry?.[0].value,

        flag_skills: (currentProfile.skills || []).length > 0,
        flag_summary: (currentProfile.summary || "").length > 0,
        flag_exeperience: currentProfile.positions?.length > 1 // experience excluding the main position
      },
      account: {
        id: currentAccount.id,
        name: currentAccount.name
      },
      location: {
        transforms: [
          {
            target: "all",
            attr: "search",
            action: "ExcludeKeys",
            data: [
              "reset_password_token",
              "welcome_token",
              "auth_token",
              "session_id",
              "api_key",
              "access_token",
              "refresh_token"
            ]
          }
        ]
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentProfile.id]);
};
